import ReactGA from "react-ga4";
import { EVENTS } from "./constants/ga-constants";
export const logPageView = (title = "") => {
  try {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "HS-" + title,
    });
  } catch (error) {}
};

export const logEvent = (eventName) => {
  try {
    console.log(EVENTS[eventName]);
    ReactGA.event(EVENTS[eventName]);
  } catch (error) {
    console.log(error);
  }
};
